import { render, staticRenderFns } from "./grabAndGoGopay.vue?vue&type=template&id=76b5c712&"
import script from "./grabAndGoGopay.vue?vue&type=script&lang=js&"
export * from "./grabAndGoGopay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports